import { SessionManager } from "../../auth/sessionManager";
import userHttp from "../../axios.services/http/instances/userHttp";

export interface RegisterPayload  {
  email: string;
  mobile: string;
  password: string;
  fullName: string;
  aadharNumber: string;
  panNumber: string;
  address: string;
  profileImage: string | null;    // base64 string (without data: prefix)
  imgExtenstion: string;   // e.g. "jpg", "png"

}

const userService = {
  login: async (payload: { email: string; password: string }) => {
    const response = await userHttp.post("/api/login", {
      email: payload.email,
      passwordHash: payload.password,
    });

    // console.log({ response });

    const wrapper = response?.data;
    const inner = wrapper?.Data ?? wrapper;

    const { token, sessionId, expiresAtUtc, userId, role } = inner;
    SessionManager.setAuth({ token, sessionId, expiresAtUtc });

    return { userId, role, token, sessionId, expiresAtUtc };
  },
  register: async (payload: RegisterPayload) => {

    // console.log({payload});
    
    const response = await userHttp.post("/api/register", {
      email: payload.email,
      mobile: payload.mobile,
      password: payload.password,
      fullName: payload.fullName,
      aadharNumber: payload.aadharNumber,
      panNumber: payload.panNumber,
      address: payload.address,
      profileImage: payload.profileImage,
      imgExtenstion: payload.imgExtenstion
    });

    // console.log({response});
    
    const wrapper = response?.data;
    const inner = wrapper?.Data ?? wrapper;
// console.log({inner});
    // assume: { message, userId, ... } aata hai
    return inner;
  },


  fetchSession: async () => {
    const response = await userHttp.get(`/session`);
    return response?.data ?? response;
  },

  logout: async () => {
    SessionManager.clear();
    const response = await userHttp.post(`/logout`);

    return response?.data ?? response;
  },
};

export default userService;
